module.exports = __webpack_public_path__ + "static/media/Gotham-MediumItalic.001670b1.woff2";